import React from "react";
import "./demo-wrapper.scss";
import { Intent } from "../common";
import { Button, InputGroup } from "../components";

const FormWrapper = () => {
  const intentList: Array<Intent> = ["none", "primary", "success", "warning"];

  return (
    <>
      <h1>📌 Form</h1>
      <div className="demo-wrapper">
        <h3>InputGroup(text) - default</h3>
        {intentList.map((i, idx) => {
          return (
            <>
              <InputGroup
                intent={i}
                placeholder="placeholder"
                label="Label"
                helperText="helper text"
              />
              <InputGroup intent={i} defaultValue={i} label="Label" required />
            </>
          );
        })}
        <InputGroup
          placeholder="placeholder"
          label="Label"
          helperText="helper text"
          disabled
        />
        <InputGroup defaultValue="disabled" label="Label" disabled />

        <InputGroup label="아이콘 ver" leftIcon="Copy" />
        <InputGroup
          defaultValue="왼쪽 테스트"
          label="버튼 ver"
          leftElement={<Button text="버튼" outlined />}
        />
        <InputGroup
          defaultValue="오른쪽버튼 테스트"
          label="버튼 ver"
          // leftElement={<Button text="버튼" />}
          rightElement={<Button text="버튼" outlined />}
        />
        <InputGroup
          defaultValue="양쪽버튼 테스트"
          label="버튼 ver"
          // leftElement={<Button text="버튼" outlined />}
          leftIcon="Docs"
          rightElement={<Button text="버튼" outlined />}
        />
      </div>

      <div className="demo-wrapper">
        <h3>InputGroup(password)</h3>
        <InputGroup
          placeholder="passward"
          label="passward"
          type="password"
          required
        />
        <InputGroup
          placeholder="passward"
          label="passward"
          type="password"
          rightElement={
            <Button intent="tertiary" icon="Close" iconsOnly minimal />
          }
          required
        />
      </div>
    </>
  );
};

export default FormWrapper;

